


















































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { MessageDetailViewModel } from '@/models/telephony/message';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import { ValidateHelper } from '@/helper/validate.helper';
import { Utils } from '@/helper/utils';
import { MetadataType } from '@/enums/enums';
import { Base } from '@/components/common/base';
import { messageService, userService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    pages() {
      return this.pagedMessages.totalPages;
    },
    validate() {
      return (
        this.selectedPaymentType &&
        Number(this.amountToBePaid) <= Number(this.finalAmount) &&
        Number(this.amountToBePaid) > 0 &&
        this.amountToBePaid !== '0.00'
      );
    },
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Calendar: () => import('@/components/common/app.calendar.vue'),
  },
})
export default class TextDashboardPage extends Base {
  public pagedMessages: MessageDetailViewModel[] = [];
  public name: 'vuetify-layout';
  public window: any = window;
  public loading: boolean = false;
  public isSearch: boolean = false;
  public customerKey: string = '';
  public advisors: any[] = [];
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;
  public advisorId: string = '';
  public isAdvisorLoaded: boolean = false;
  public disableDefaultDateRange: boolean = false;
  public calendarKey: number = 0;

  public messageTypes: any[] = [
    {
      text: this.$parent.$t('textDashboard.messageTypes.appointment') as string,
      value: 'Appointment',
    },
    {
      text: this.$parent.$t('textDashboard.messageTypes.ro') as string,
      value: 'RO',
    },
    {
      text: this.$parent.$t('textDashboard.messageTypes.deal') as string,
      value: 'Deal',
    },
    {
      text: this.$parent.$t('textDashboard.messageTypes.attachment') as string,
      value: 'Attachment',
    },
    {
      text: this.$parent.$t('textDashboard.messageTypes.orphan') as string,
      value: 'Orphan',
    },
  ];
  public headers: VHeaders[] = [
    {
      text: this.$parent.$t('textDashboard.epicorGrid.time1') as string,
      value: 'createdAt',
      align: 'left',
      sortable: true,
      filters: [
        (v) => {
          if (v && v !== 'N/A') {
            return this.$moment(v).format('lll');
          }
        },
      ],
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.user') as string,
      align: 'left',
      value: 'attendingUserName',
      sortable: true,
      filters: [
        (v: string) => {
          return v || 'Unattended';
        },
      ],
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.sender') as string,
      align: 'left',
      value: 'sender',
      sortable: false,
      filters: [
        (v: string, item: MessageDetailViewModel) => {
          return (item.sender || '') + '  ' + this.formatPhone(item.from);
        },
      ],
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.receiver') as string,
      align: 'left',
      value: 'receiver',
      sortable: false,
      filters: [
        (v: string, item: MessageDetailViewModel) => {
          return (item.receiver || '') + '  ' + this.formatPhone(item.to);
        },
      ],
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.direction') as string,
      align: 'left',
      value: 'direction',
      sortable: false,
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.message') as string,
      align: 'left',
      value: 'messageBody',
      sortable: false,
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.status') as string,
      align: 'left',
      value: 'status',
      filters: [
    (v: string) => {
      if (!v) return 'N/A';
      const s = v.toString().trim();
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
  ],
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.readStatus') as string,
      align: 'left',
      value: 'isReadJson',
      filters: [
        (v: boolean) => {
          return v ? 'Read' : 'Unread';
        },
      ],
      sortable: false,
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.type') as string,
      value: 'conversationType',
      align: 'left',
      filters: [
        (v: string, item: MessageDetailViewModel) => {
          return item.recordIdentifier + ' (' + item.conversationType + ')';
        },
      ],
      sortable: false,
    },
    {
      text: this.$parent.$t('textDashboard.epicorGrid.action') as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];
  public actions: any[] = [];
  public deals: MessageDetailViewModel[] = [];
  public searchParameters: any = {
    selectedAdvisors: [],
    messageTypes: [],
    fromDate: '',
    toDate: '',
    showUnRead: true,
    showOrphan: false,
  };
  public pagination = new PaginationModel('id');
  public isAdminDashboardView: boolean = false;
  constructor() {
    super();
  }

  public setActions() {
    this.actions = [
      {
        type: 'link',
        icon: 'fas fa-comment',
        title: this.$parent.$t(
          'textDashboard.epicorGrid.gridActions.sendMessage'
        ) as string,
        visible: (model: MessageDetailViewModel) => {
          return true;
        },
        action: (model: MessageDetailViewModel) => {
          return {
            name: 'common.conversation.add',
            params: {
              tenantId: this.tenantId.toString(),
              enterpriseId: this.enterpriseId.toString(),
              storeId: this.storeId,
              type: MetadataType[MetadataType.Orphan],
            },
            query: {
              customerKey: model.customerKey,
              recordKey:
                model.direction === 'Inbound'
                  ? encodeURIComponent(model.from)
                  : encodeURIComponent(model.to),
            },
          };
        },
      },
    ];
  }
  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'searchMessage') {
      this.searchMessage();
    }
    if (methodName === 'resetFilters') {
      this.resetFilters();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }

  public updateToolBar(): void {
    // let buttons: any = [];
    // buttons.push({'id':'0', 'type':'button', 'title':'Search', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Search', 'click':'searchMessage', 'icon':'fas fa-search','requestProgress': true});
    // buttons.push({'id':'1', 'type':'button', 'title':'ResetFilters', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Reset Filters', 'click':'resetFilters', 'icon':'fas fa-redo', 'requestProgress': true});
    // this.$emit('updateToolBar', buttons);
  }

  public mounted(): void {
    // activating tab
    if(this.$route.params.viewmode == 'admintextdashboard'){
      this.$root.$emit('sidebar.layout.vue', 'adminTextDashboard');
    }else if(this.$route.params.viewmode == 'mytextdashboard'){
      this.$root.$emit('sidebar.layout.vue', 'mytextdashboard');
    }
    
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    if (this.$route.query.advisorId) {
      this.advisorId = this.$route.query.advisorId as string;
    }
    
    const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
    if (pagination) {
      
      this.searchParameters.selectedAdvisors = this.$route.query.selectedAdvisors;
      this.searchParameters.messageTypes = this.$route.query.messageTypes;
      this.searchParameters.fromDate = this.$route.query.fromDate != undefined ? this.$route.query.fromDate.toString() : '';
      this.searchParameters.toDate =  this.$route.query.toDate != undefined ? this.$route.query.toDate.toString() : '';
      this.searchParameters.showUnRead = Boolean(JSON.parse(this.$route.query.showUnRead.toString()));
      this.searchParameters.showOrphan = Boolean(JSON.parse(this.$route.query.showOrphan.toString()));

      this.pagination = pagination;
    }
    // this.getMessages();
    this.setActions();
  }

  public updatePaging(paging: any): void {
    
    this.pagination = paging;
    const queryStringObj = Object.assign({}, paging);
    if(queryStringObj){
      queryStringObj.selectedAdvisors = this.searchParameters.selectedAdvisors;
      queryStringObj.messageTypes = this.searchParameters.messageTypes;
      queryStringObj.fromDate = this.searchParameters.fromDate;
      queryStringObj.toDate = this.searchParameters.toDate;
      queryStringObj.showUnRead = this.searchParameters.showUnRead;
      queryStringObj.showOrphan = this.searchParameters.showOrphan;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getMessages();
  }

  public updateView() {
    
    if (this.$route.params.viewmode === 'admintextdashboard') {
      this.isAdminDashboardView = true;
      this.advisorId = this.$route.query.advisorId as string;
      this.getadvisors();
    } else {
      
      this.isAdminDashboardView = false;
      this.searchMessage();
    }
  }

  public created(): void {
    if (this.$route.query.fromDate && this.$route.query.toDate) {
      this.searchParameters.fromDate = (this.$route.query.fromDate).toString();
      this.searchParameters.toDate = (this.$route.query.toDate).toString();
    }
    else{
      this.searchParameters.fromDate = this.presentDate();
      this.searchParameters.toDate = this.presentDate();
    }

    this.$watch('isAdminDashboardView', (newVal, oldVal) => {
      this.updateView();
    });
  }

  public resetFilters() {
    
    this.searchParameters.selectedAdvisors = [];
    this.searchParameters.messageTypes = [];
    this.searchParameters.fromDate = '';
    this.searchParameters.toDate = '';
    (this.searchParameters.showUnRead = false),
    (this.searchParameters.showOrphan = false);

    this.disableDefaultDateRange = true;
    this.calendarKey++;

    const queryStringObj = Object.assign({}, this.pagination) as any;
    if(queryStringObj){
      queryStringObj.selectedAdvisors = this.searchParameters.selectedAdvisors;
      queryStringObj.messageTypes = this.searchParameters.messageTypes;
      queryStringObj.fromDate = this.searchParameters.fromDate;
      queryStringObj.toDate = this.searchParameters.toDate;
      queryStringObj.showUnRead = this.searchParameters.showUnRead;
      queryStringObj.showOrphan = this.searchParameters.showOrphan;
    }
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getMessages();
  }
  public async getadvisors(): Promise<void> {
    this.isAdvisorLoaded = true;
    const storeUser = await userService.getStoreUsersByRoleAsync(
      this.storeId,
      'Advisor'
    );
    this.advisors = storeUser;
    if (this.advisorId) {
      this.searchParameters.selectedAdvisors = [this.advisorId];
    }
    
    this.searchMessage();
    if (!storeUser.length) {
      this.advisors = [];
    }
    this.isAdvisorLoaded = false;
  }
  public async getMessages(): Promise<void> {
    
    try {
      this.loading = true;
      this.$emit('update:progress', this.loading);
      this.isSearch = true;
      const messages = await messageService.getMessages(
        this.isAdminDashboardView,
        this.pagination,
        this.searchParameters
      );
      
      this.pagedMessages = messages.results;
      this.pagination.totalItems = messages.total;
      
    } finally {
      this.loading = false;
      this.$emit('update:progress', this.loading);
    }
  }

  public searchMessage() {
    this.isSearch = true;
    this.pagination.page = 1;
    const queryStringObj = Object.assign({}, this.pagination) as any;
    queryStringObj.fromDate = this.searchParameters.fromDate;
    queryStringObj.toDate = this.searchParameters.toDate;
    queryStringObj.showUnRead = this.searchParameters.showUnRead;
    queryStringObj.showOrphan = this.searchParameters.showOrphan;
    queryStringObj.messageTypes = this.searchParameters.messageTypes;
    queryStringObj.selectedAdvisors = this.searchParameters.selectedAdvisors;
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getMessages();
  }

  public rowsPerPage(rowsPerpage): void {
    if (rowsPerpage !== this.pagination.rowsPerPage) {
      
      this.pagination.rowsPerPage = rowsPerpage;
      this.pagination.page = 1;
      this.updatePaging(this.pagination);
    }
  }
  public formatPhone(phone: string) {
    if (phone) {
      return ValidateHelper.formatPhone(phone);
    }
  }
  public setDateParametersDashboard(dates: any) {
    if (dates.length > 1) {
      this.disableDefaultDateRange = false;
      this.searchParameters.fromDate = dates[0];
      this.searchParameters.toDate = dates[1];
    }
  }
}
